import AdminRoute from '../adminRoute';
import { PATH_NAME } from '../pathNames';
import { ManageCriterion } from '../lazyLoaded';
import { ALL_PERMISSIONS } from '../../utils/constants';

const ManageCriterionRoute = () => (
  <AdminRoute
    exact
    path={PATH_NAME.MANAGE_CRITERION}
    permission={ALL_PERMISSIONS.CAN_ACCESS_MANAGE_CRITERION_PAGE}
    component={(props: JSX.IntrinsicAttributes) => (
      <ManageCriterion {...props} />
    )}
  />
);
export default ManageCriterionRoute;
